import {Blockquote} from "@wfp/ui";
import {useTranslation} from "react-i18next";
import {surveyWizardPages} from "./wizard"

export interface HeaderProps {
    page: number
    errors?: string[]
    message?: string
}

export function HeaderSurveybar(props: HeaderProps) {
    const {t} = useTranslation();
    return (
        <div>
            <div className="flex mt-2 mb-2">
                {props.page !== undefined && (
                <div className="m-0">{t("step")} {t((props.page + 1).toString())}/{t((surveyWizardPages.length).toString())}: {t(surveyWizardPages[props.page].header)}</div>
                )}
            </div>
            {!!props.errors && (
                <Blockquote kind="error" withIcon>{props.errors.toString()}</Blockquote>
            )}
            {!!props.message && (
                <Blockquote kind="info" withIcon>{props.message}</Blockquote>
            )}
        </div>
    )
}
